import { type FC, type ReactNode, useReducer } from 'react';

import { Toasts } from './Toasts.tsx';
import { ToastDispatchContext, ToastStateContext } from './context.ts';
import { reducer, initialState } from './reducer.ts';

type ToastProviderProps = {
    children: ReactNode;
};

const ToastProvider: FC<ToastProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <ToastDispatchContext value={dispatch}>
            <ToastStateContext value={state}>
                {children}
                <Toasts />
            </ToastStateContext>
        </ToastDispatchContext>
    );
};

export { ToastProvider };
